// extracted by mini-css-extract-plugin
module.exports = {"infoBar":"postView_infoBar__1rrfF","codeblock":"postView_codeblock__3sG1z"};